import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useInriStore } from '../stores/inriStore'


export default /*#__PURE__*/_defineComponent({
  props: {
  showing: Boolean,
},
  setup(__props) {



const inriStore = useInriStore()

return (_ctx: any,_cache: any) => {
  const _component_c_spinner = _resolveComponent("c-spinner")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!

  return (_openBlock(), _createBlock(_component_q_inner_loading, {
    showing: __props.showing || _unref(inriStore).state.showPageSpinner,
    class: "z-max"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_c_spinner)
    ]),
    _: 1
  }, 8, ["showing"]))
}
}

})